export enum DashboardMode {
  VIEW = 'VIEW',
  EDIT = 'EDIT',
  SAVE = 'SAVE'
}
